import { useFormContext, useWatch } from '@portals-platform/ui-forms';
import { useMemo } from 'react';
import { useCaptivePolicies } from '../../../data-access/index.js';
import type { CaptivePolicy } from '../../../data-access/models.js';
import { getPolicyForYear } from '../policy.js';
import type { FormValues } from '../types.js';

export function useSelectedPolicy(): CaptivePolicy | null {
  const { control } = useFormContext<FormValues>();
  const policyYear = useWatch({ control, name: 'policyYear' });
  const policies = useCaptivePolicies();

  return useMemo(() => getPolicyForYear({ policies, policyYear }), [policies, policyYear]);
}
